module.exports = __webpack_public_path__ + "img/2.8667c333.svg";